// src/services/api/productWiseSalesReport.js
import { apiClient } from './base';

/**
 * Get the Product Wise Sales report (summary cards + paginated product rows).
 * @param {Object} params
 * @param {string} params.shopIds         - CSV of shop ids (omit for all assigned shops)
 * @param {string} params.dateFrom        - YYYY-MM-DD (dispatched date)
 * @param {string} params.dateTo          - YYYY-MM-DD (dispatched date)
 * @param {string} params.search          - product name search
 * @param {string} params.orderBy         - column key
 * @param {string} params.orderDirection  - 'ASC' | 'DESC'
 * @param {number} params.page
 * @param {number} params.limit
 * @param {boolean} params.all            - return every row (exports)
 * @returns {Promise<Object>} { summary, rows, total }
 */
export const getProductWiseSalesReport = async (params = {}) => {
  const response = await apiClient.get('/reports/product-wise-sales', { params });
  return response.data;
};
